import React from "react";

// Shows a friendly message with Reload instead of a blank page if a screen crashes.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Screen error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream p-6">
        <div className="max-w-md w-full bg-white rounded-xl shadow-lg border border-[#E5D9C5] p-6 text-center">
          <p className="font-heading text-xl font-bold text-maroon-900">Something went wrong on this screen</p>
          <p className="text-sm text-slate-600 mt-2">Your data is safe. Reload to continue.</p>
          <button type="button" onClick={() => window.location.reload()}
            className="mt-5 px-6 h-11 rounded-md bg-maroon-700 hover:bg-maroon-800 text-white font-semibold">Reload</button>
          <p className="text-[11px] text-slate-400 mt-4 break-all">{String(this.state.error?.message || this.state.error)}</p>
        </div>
      </div>
    );
  }
}
